<template>
    <div class="mt-2">
        <div class="alert" :class="alertClass">
            <b>{{ fileName }}: {{ heading }}</b>
            <ul class="mb-0" v-if="report.ok && report.summary.length">
                <li v-for="(line, idx) in report.summary" :key="idx">{{ line }}</li>
            </ul>
        </div>

        <div v-for="section in sections" :key="section.title" class="mb-3">
            <h6 :class="section.titleClass">{{ section.title }}</h6>
            <table class="table table-sm table-bordered small mb-1">
                <thead>
                    <tr>
                        <th>Sheet</th>
                        <th>Row</th>
                        <th>Column</th>
                        <th>Message</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in section.items.slice(0, maxRows)" :key="idx">
                        <td>{{ item.sheet }}</td>
                        <td>{{ item.row || '' }}</td>
                        <td>{{ item.column }}</td>
                        <td>{{ item.message }}</td>
                    </tr>
                </tbody>
            </table>
            <p class="text-muted small" v-if="section.items.length > maxRows">
                And {{ section.items.length - maxRows }} more.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['report', 'fileName', ],
    data() {
        return {
            maxRows: 500,
        }
    },
    computed: {
        heading() {
            if (!this.report.ok) {
                return `${this.report.errors.length} error(s) found. Nothing was imported; fix the file and upload it again.`
            }
            if (this.report.dry_run) {
                return 'The file is valid. Ready to import:'
            }
            return 'Imported:'
        },
        alertClass() {
            if (!this.report.ok) {
                return 'alert-danger'
            }
            return this.report.dry_run ? 'alert-info' : 'alert-success'
        },
        sections() {
            const sections = []
            if (this.report.errors.length) {
                sections.push({title: `Errors (${this.report.errors.length})`, titleClass: 'text-danger', items: this.report.errors})
            }
            if (this.report.warnings.length) {
                sections.push({title: `Warnings (${this.report.warnings.length})`, titleClass: 'text-warning', items: this.report.warnings})
            }
            return sections
        },
    },
}
</script>
